<link rel="stylesheet" href="../../core/typography.scss">
<template>
  <div data-page="overview">
    <div class="main">

      <div class="callout-block">

        <div class="callout-block-heading">
          <template v-if="form.percentComplete < 100">
            <svg class="block-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
              <path fill="#D91C1C" d="M25,4c7.76,0,14.53,4.24,18.17,10.51l3.48-2.01C42.33,5.03,34.25,0,25,0S7.67,5.03,3.35,12.5l3.48,2.01C10.47,8.24,17.24,4,25,4z"/>
              <path fill="#FFAC26" d="M46,25c0,11.58-9.42,21-21,21v4c13.81,0,25-11.19,25-25c0-4.55-1.22-8.82-3.35-12.5l-3.48,2.01C44.96,17.6,46,21.18,46,25z"/>
              <path fill="#00C2AE" d="M25,50v-4C13.42,46,4,36.58,4,25c0-3.82,1.04-7.4,2.83-10.49L3.35,12.5C1.22,16.18,0,20.45,0,25C0,38.81,11.19,50,25,50z"/>
              <path fill="#0061A6" d="M36,19H21c-1.1,0-2-0.9-2-2s0.9-2,2-2h15c1.1,0,2,0.9,2,2S37.1,19,36,19z"/>
              <path fill="#0061A6" d="M36,27H21c-1.1,0-2-0.9-2-2s0.9-2,2-2h15c1.1,0,2,0.9,2,2S37.1,27,36,27z"/>
              <path fill="#0061A6" d="M36,35H21c-1.1,0-2-0.9-2-2s0.9-2,2-2h15c1.1,0,2,0.9,2,2S37.1,35,36,35z"/>
              <circle fill="#0061A6" cx="14.5" cy="17" r="2.5"/>
              <circle fill="#0061A6" cx="14.5" cy="25" r="2.5"/>
              <circle fill="#0061A6" cx="14.5" cy="33" r="2.5"/>
            </svg>
          </template>
          <template v-else>
            <svg class="block-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
              <path fill="#0095ff" d="M16.2,31.05l-5.02-5.02c-0.78-0.78-2.05-0.78-2.83,0c-0.78,0.78-0.78,2.05,0,2.83l6.44,6.44c0.39,0.39,0.9,0.59,1.41,0.59c0.51,0,1.02-0.2,1.41-0.59l1.41-1.41L16.2,31.05L16.2,31.05z"/>
              <path fill="#0095ff" d="M30.82,22.08l2.05-2.05c0.78-0.78,0.78-2.05,0-2.83c-0.78-0.78-2.05-0.78-2.83,0l-8.89,8.89l2.83,2.83L30.82,22.08z"/>
              <path fill="#0061A6" d="M23.98,35.88c-0.51,0-1.02-0.2-1.41-0.59l-6.44-6.44c-0.78-0.78-0.78-2.05,0-2.83c0.78-0.78,2.05-0.78,2.83,0l5.02,5.02l13.84-13.84c0.78-0.78,2.05-0.78,2.83,0c0.78,0.78,0.78,2.05,0,2.83L25.39,35.29C25,35.68,24.49,35.88,23.98,35.88z"/>
              <path fill="#D91C1C" d="M25,4c7.76,0,14.53,4.24,18.17,10.51l3.48-2.01C42.33,5.03,34.25,0,25,0S7.67,5.03,3.35,12.5l3.48,2.01C10.47,8.24,17.24,4,25,4z"/>
              <path fill="#FFAC26" d="M46,25c0,11.58-9.42,21-21,21v4c13.81,0,25-11.19,25-25c0-4.55-1.22-8.82-3.35-12.5l-3.48,2.01C44.96,17.6,46,21.18,46,25z"/>
              <path fill="#00C2AE" d="M25,50v-4C13.42,46,4,36.58,4,25c0-3.82,1.04-7.4,2.83-10.49L3.35,12.5C1.22,16.18,0,20.45,0,25C0,38.81,11.19,50,25,50z"/>
            </svg>
          </template>
          <div class="callout-block-heading-copy">
            <template v-if="form.percentComplete < 100">
              <div class="callout-block-heading-copy-eyebrow">{{ $t('assessment-overview') }}</div>
            </template>
            <template v-else>
              <div class="callout-block-heading-copy-eyebrow">{{ $t('assessment-complete') }}</div>
            </template>
            <div class="callout-block-heading-copy-title">{{ submission.name }}</div>
          </div>
        </div>

        <div class="callout-block-progress-section">
          <div class="callout-block-progress-section-eyebrow">{{ $t('progress') }}</div>
          <div class="callout-block-progress-section-row" v-for="page in form.pages">
            <div class="row-content">
              <div class="callout-block-progress-section-meta">
              <span class="callout-block-progress-section-name">
                <router-link :to="`/${getLocale()}/form/${page.id}?id=${submission.id}`">
                  {{ page.name.get() }}
                </router-link>
              </span>
                <span class="callout-block-progress-section-percent">{{ page.percentComplete }}%&nbsp;{{ $t('percent-complete') }}</span>
              </div>

              <div class="callout-block-progress-bar-track" :style="`--progress: ${page.percentComplete}`">
                <div class="callout-block-progress-bar-bar">
                  <div class="callout-block-progress-bar-gradient"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="callout-block-actions">
          <div class="callout-block-actions-label">
            <template v-if="form.percentComplete < 100">
              <div class="callout-block-actions-label-eyebrow">{{ nextPage.eyebrow }}</div>
              <div class="callout-block-actions-label-title">{{ nextPage.page.name.get() }}</div>
            </template>
            <template v-else>
              <div class="callout-block-actions-label-eyebrow">{{ $t('next-steps') }}</div>
              <div class="callout-block-actions-label-title">{{ $t('view-report-complete-survey') }}</div>
            </template>
          </div>
          <div class="callout-block-actions-buttons">
            <template v-if="form.percentComplete < 100">
              <router-link :to="`/${$i18n.locale}/form/${nextPage.page.id}?id=${submission.id}`">
                <button type="button" class="rect">{{ nextPage.button }}</button>
              </router-link>
            </template>
            <template v-else>
              <a target="_blank" @click="onDownloadReport(submission.id)">
                <button type="button" class="rect">{{ $t('download-report') }}</button>
              </a>
              <a target="_blank" :href="$t('survey-url')">
                <button type="button" class="rect">{{ $t('complete-survey') }}</button>
              </a>
            </template>
          </div>
        </div>
      </div>


      <div class="secondary-actions">

        <div class="active-program button" v-if="selectSubmissions.length > 1">
          <div class="select-wrapper button-indicator">
            <select v-model="selectSubmissionId" @change="onProgramSelected($event)">
              <option v-for="aSubmission in selectSubmissions" :value="aSubmission.id">{{ aSubmission.name }}</option>
            </select>
          </div>
          <div class="button-label">{{ submission.name }}</div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <path d="M8.95,9.05L7.5,7.6L12,3.1l4.5,4.5l-1.45,1.45L12,6L8.95,9.05z M12,21l-4.5-4.5l1.45-1.45L12,18.1l3.05-3.05l1.45,1.45L12,21z"/>
          </svg>
        </div>

        <a class="button" :href="`/${$i18n.locale}/programs`">
          <div class="button-indicator"></div>
          <div class="button-label">{{ $t('manage-program-assessments') }}</div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <path d="M12,4c3.87,0,6.67,0,7.34,0.66C20,5.33,20,8.13,20,12s0,6.67-0.66,7.34C18.67,20,15.87,20,12,20s-6.67,0-7.34-0.66C4,18.67,4,15.87,4,12s0-6.67,0.66-7.34C5.33,4,8.13,4,12,4 M12,2C2,2,2,2,2,12s0,10,10,10s10,0,10-10S22,2,12,2L12,2z M15.75,12c0-0.2-0.02-0.42-0.05-0.65l1.15-1l-1-1.7L14.4,9.1c-0.18-0.13-0.36-0.25-0.54-0.34C13.69,8.67,13.5,8.58,13.3,8.5L13,7h-2l-0.3,1.5c-0.2,0.08-0.39,0.17-0.56,0.26C9.96,8.85,9.78,8.97,9.6,9.1L8.15,8.65l-1,1.7l1.15,1C8.27,11.58,8.25,11.8,8.25,12s0.02,0.42,0.05,0.65l-1.15,1l1,1.7L9.6,14.9c0.18,0.13,0.36,0.25,0.54,0.34c0.18,0.09,0.36,0.18,0.56,0.26L11,17h2l0.3-1.5c0.2-0.08,0.39-0.17,0.56-0.26c0.17-0.09,0.35-0.2,0.54-0.34l1.45,0.45l1-1.7l-1.15-1C15.73,12.42,15.75,12.2,15.75,12z M12,14c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,14,12,14z"/>
          </svg>
        </a>

      </div>


    </div>
  </div>
</template>

<script lang="ts" setup>
import Manager from '../../core/Manager';
import QualityMentoringForm from '../quality-mentoring-form/models/QualityMentoringForm';
import { getLocale } from '../../core/Utils';
import { useRoute } from 'vue-router';
import { onMounted, ref } from "vue";
import RestService from 'restService';
import { onDownloadReport } from '../../core/Utils';

const route = useRoute();
const submission = Manager.getInstance().submission;

const manager = Manager.getInstance();

const selectSubmission = ref(Manager.getInstance().submission)
const selectSubmissions = ref(Manager.getInstance().submissions.list);
const selectSubmissionId = ref(selectSubmission.value.id);

if(!submission.data.root) submission.data.root = {};
const form = QualityMentoringForm.getInstance()
form.pages.forEach((page) => {
  form.updateMetrics(submission, page.id);
})

const getNextPage = () => {
  let page = null;
  let eyebrow = null;
  let button = null;

  if(percentComplete > 0 && percentComplete < 100) {
    let currentPageId = parseInt(route.query.active);
    if(currentPageId) {
      page = form.pages.find((page) => page.id === currentPageId);
      eyebrow = manager.i18n.global.t('continue-principle');
      button = manager.i18n.global.t('continue');
    }
    else {
      const incompletePages = form.pages.filter((page) => page.percentComplete < 100);
      page = incompletePages[0];
      eyebrow = manager.i18n.global.t('next-principle');
      button = manager.i18n.global.t('continue');
    }
  }
  else if(percentComplete === 0) {
    page = form.pages.find((page) => page.id === 1);
    eyebrow = manager.i18n.global.t('get-started-capitalized');
    button = manager.i18n.global.t('begin')
  }

  return {
    page: page,
    eyebrow: eyebrow,
    button: button
  };
}

const percentComplete = form.percentComplete;
const nextPage = getNextPage();

function onProgramSelected() {
  const redirect = `${route.path}?id=${selectSubmissionId.value}`;
  window.location.href = redirect;
}

onMounted(() => {
  document.body.classList.remove('loading');
});
</script>
